import {Component, HostListener, OnInit} from '@angular/core';
import {EventService} from "../services/event.service";
import {Event} from "../models/event";
import {Router} from "@angular/router";
import {AuthenticationService} from "../services/authentication.service";
import {CATEGORIES} from "../constants/categories";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  categories = CATEGORIES;

  // Database counters variables
  activity_number: number = 0;
  location_number: number = 0;
  participant_number: number = 0;

  // Events and event filtering variables
  searchTerm: string = '';
  loadingEvents: Boolean = true;
  events!: Event[];

  // Screen calculation variables
  screen_width!: number;
  hide_small!: boolean;
  hide_medium!: boolean;
  hide_large!: boolean;

  constructor(
    private eventService: EventService,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.eventService.init(4);
    this.onResize();

    this.events = this.eventService.getEvents();

    await this.eventService.countEvents().then(data => {
      this.activity_number = data.users;
      this.location_number = data.uniqueLocations;
      this.loadingEvents = false;
    })

    await this.authService.countUsers().then(number => {
      this.participant_number = number;
    });
  }

  searchActivities() {
    this.router.navigate(['/activiteiten'], { queryParams: { query: this.searchTerm }, replaceUrl: true});
  }

  /**
   * Checks if the window size corresponds to one of the size limits
   *
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.screen_width = window.innerWidth;
    this.hide_small = this.screen_width <= 576;
    this.hide_medium = this.screen_width <= 750;
    this.hide_large = this.screen_width <= 820;
  }
}
